import { useEffect, useState } from "react";
import axios from "axios";

const MATCH_LINE = "We will match or beat any written quote on the same TV.";
let cached;
let pending = null;

const fmtDate = (iso) => new Date(`${iso}T12:00:00`).toLocaleDateString("en-US", { month: "long", day: "numeric", year: "numeric" });

export const promoText = (p) => p.banner_text || `${p.percent}% off equipment, mounts, and installs through ${fmtDate(p.end)}.`;
export const promoNoStackLine = (p) => `Price matches can't be combined with the ${p.percent}% off on the TV.`;
export const promoMatchLine = (p) => (p.match_beat ? `${MATCH_LINE} ${promoNoStackLine(p)}` : "");
const THEMES = [
  [/halloween/i, "halloween"], [/black friday|cyber/i, "blackfriday"], [/veteran/i, "veterans"], [/thanksgiving/i, "thanksgiving"],
  [/christmas/i, "christmas"], [/new year/i, "newyear"], [/super bowl/i, "superbowl"], [/valentine/i, "valentines"],
  [/president/i, "presidents"], [/patrick/i, "stpatricks"], [/easter/i, "easter"], [/mother/i, "mothersday"],
  [/memorial/i, "memorial"], [/father/i, "fathersday"], [/july|independence|4th/i, "july4"], [/labor/i, "laborday"],
];
export const promoTheme = (p) => (THEMES.find(([re]) => re.test(p.name)) || [null, "default"])[1];
export const promoImage = (p) => (promoTheme(p) === "default" ? null : `/promos/${promoTheme(p)}.webp`);
export const promoLineLabel = (p) => `${p.name} special, ${p.percent}% off${p.covers_addons ? "" : " install and mount"}`;

// Current live promotion from the admin panel, or null. undefined while loading.
export const useCurrentPromo = () => {
  const [promo, setPromo] = useState(cached);
  useEffect(() => {
    if (cached !== undefined) return;
    pending = pending || axios.get(`${process.env.REACT_APP_BACKEND_URL}/api/promotions/current`).then((r) => (cached = r.data || null));
    pending.then(setPromo).catch(() => { pending = null; setPromo(null); });
  }, []);
  return promo;
};
